function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.1306 29.0862C31.8987 28.8818 31.5887 28.7867 31.2814 28.8252C30.136 28.9697 28.3271 29.1357 26.5182 29.0544C25.2804 28.9972 24.1564 28.7532 23.0934 28.4168L19.2926 17.536C22.9148 16.3691 25.9504 15.8992 27.6499 15.7134C28.0045 15.6744 28.3145 15.4644 28.4827 15.1511C28.6508 14.8378 28.653 14.4619 28.4887 14.1464C26.173 9.68712 21.0696 7.33959 16.147 8.53452L16.0558 8.27344C15.9612 8.00356 15.7639 7.78206 15.5072 7.65839C15.25 7.53472 14.9543 7.51768 14.6838 7.61222L14.6663 7.61826C14.1051 7.81448 13.8088 8.42844 14.005 8.99017L14.0957 9.25015C9.51115 11.3723 6.98004 16.3625 7.91993 21.2802C7.98753 21.6331 8.22608 21.9288 8.55532 22.0695C8.88565 22.2102 9.26381 22.1778 9.56446 21.9821C10.9215 21.0999 13.4362 19.6654 17.2402 18.2506L20.4359 27.401C17.8536 26.3067 15.3835 25.1612 12.1214 25.6587C10.0366 25.9764 8.39207 27.6176 7.77042 28.3239C7.59839 28.5212 7.5 28.7735 7.5 29.0351V31.3728C7.5 31.9675 7.98698 32.4495 8.5817 32.4495H31.4183C32.013 32.4495 32.5005 31.9675 32.5005 31.3728V29.8937C32.4989 29.5848 32.3626 29.2907 32.1306 29.0862Z",
  fill: "#D7D6E0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 25,
  fill: "white",
  transform: "translate(7.5 7.5)"
})));

var SvgBeach = function SvgBeach(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeach, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beach.7856f71c.svg";
export { ForwardRef as ReactComponent };